import moment from 'moment';

export const DATE_OFFSET_UNITS = ['years', 'months', 'days'];
export const isRelativeDateBound = (value) => value !== null && typeof value === 'object'
  && !Array.isArray(value) && value.relative === 'today';
export const isValidRelativeDateBound = (value) => isRelativeDateBound(value)
  && Number.isSafeInteger(value.offset) && DATE_OFFSET_UNITS.includes(value.unit);

export const getDateValidationBound = (field, name) => {
  let { extra } = field;
  if (typeof extra === 'string') {
    try { extra = JSON.parse(extra); } catch (_error) { extra = {}; }
  }
  const stored = extra?.validate?.[name];
  return isRelativeDateBound(stored) ? stored : field.validate?.[name];
};

// Resolve at validation time so an open form also follows the changing day.
export const resolveDateValidationBound = (value, type, name, now = new Date()) => {
  if (value == null || value === '') return null;
  let date;
  if (isRelativeDateBound(value)) {
    if (!isValidRelativeDateBound(value)) return null;
    date = moment(now).startOf('day').add(value.offset, value.unit);
  } else {
    if (typeof value !== 'string') return null;
    date = moment(value, moment.ISO_8601, true);
  }
  if (!date.isValid()) return null;
  if (type === 'date' || isRelativeDateBound(value)) {
    date = name === 'max' ? date.endOf('day') : date.startOf('day');
  }
  return date.toDate();
};

export const applyDateValidationBounds = (schema, field) => {
  let result = schema;
  ['min', 'max'].forEach((name) => {
    const configured = getDateValidationBound(field, name);
    if (configured == null || configured === '') return;
    result = result.test(`date-${name}`, function (value) {
      if (value == null) return true;
      const limit = resolveDateValidationBound(configured, field.type, name);
      if (!limit) return this.createError({
        message: 'El límite de fecha configurado no es válido.', 
      });
      const valid = name === 'min' ? value >= limit : value <= limit;
      return valid || this.createError({
        message: name === 'min'
          ? `La fecha debe ser igual o posterior a ${moment(limit).format(field.type === 'datetime' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD')}.`
          : `La fecha debe ser igual o anterior a ${moment(limit).format(field.type === 'datetime' ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD')}.`,
      });
    });
  });
  return result;
};
